<template>
	<unauth-layout>
		<template slot="page-content">
			<div id="swagger-ui"></div>
		</template>
	</unauth-layout>
</template>

<script>
const logger = require("@/utils/logger");
import SwaggerUI from "swagger-ui";
require("swagger-ui/dist/swagger-ui.css");

export default {
  mounted() {
    SwaggerUI({
      dom_id: "#swagger-ui",
      // https://petstore.swagger.io/?_ga=2.176264933.1197198408.1537428865-79965731.1537428865
      url: "/static/openapi/api-v1.yaml"
    });
  }
};
</script>

<style scoped>
h3 {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/OpenAPI.vue